/**
 * The visible dismiss on a dialog — the glyph in the corner of a `ModalCard`.
 *
 * 🔴 THE ✕ IS A GLYPH, NOT AN ICON FROM THE SET, AND THAT IS DELIBERATE.
 * `dashIcons`' `CrossIcon` says in its own note *"NOT A 'CLOSE' ICON … this is
 * the mark for a child who is absent"* — borrowing it here would put the
 * absence mark on a dismiss control.
 *
 * ⚠️ `aria-label` RATHER THAN VISIBLE TEXT, because the glyph is the control. A
 * bare `✕` is announced as "multiplication x" or as nothing at all.
 *
 * ⚠️ IT IS NOT THE ONLY WAY OUT — Escape and pressing outside both close the
 * dialog, and `ModalCard` owns both. This is the one a reader can SEE, which is
 * the only reason a dialog needs a visible close at all.
 *
 * ⚠️ SHARED RATHER THAN PER-SCREEN. It began inside `TeachersScreen`, and the
 * moment the Classes dialog needed the same corner the choice was one
 * implementation or two that drift — the argument `ModalCard` already makes
 * about six hand-rolled overlays, one size down.
 */
export function CloseButton({ label, onClose }: { label: string; onClose: () => void }) {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label={label}
      className="-mt-1 -mr-1 shrink-0 rounded-lg p-1 text-lg font-bold text-muted transition-colors hover:bg-canvas hover:text-ink"
    >
      ✕
    </button>
  )
}
